import { createFileRoute } from '@tanstack/react-router';
import { StagesRecipesConfig } from '../../../features/production-packconv/components/StagesRecipesConfig';

/** Stages &amp; recipes config (BUILD_SPEC.md §5.5, §11 Settings) — this goal's
 * sole ownership (plan.md QC fix #2). */
export const Route = createFileRoute('/_authenticated/production-packconv/stages')({
  component: StagesRecipesConfig,
});
